import { config } from 'core/configuration/browser';
export function createCall(c) {
    return Object.assign(Object.assign({}, c), { start: new Date(c.start), stop: c.stop ? new Date(c.stop) : undefined, getCallAudioUrl() {
            return `${config.getConfig().apiHost}/api/v1.0/call-audio/${c.id}`;
        } });
}
